// Font Awesome 5 Vue component https://fontawesome.com
// @see https://github.com/FortAwesome/vue-fontawesome#usage
// @see https://fontawesome.com/icons?d=gallery - search for icons!
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export function initFontAwesome( { app, } ) {
	app.component( "FontAwesomeIcon", FontAwesomeIcon ); // I hate dashed-case component names, Vue conventions be darned
}

/* eslint-disable no-magic-numbers */
// Custom FA5 icon for the teaming logo
const teamingLogoSolid = {
	prefix: "fac", // for font-awesome-custom....just the facs, ma'am.
	iconName: "teaming-logo-solid",
	icon: [ 64, 60, [], "e001", "M45.9636 18.365C55.8545 18.365 63.9354 26.4458 64 36.4013V59.9973H55.9838V36.4013C55.9838 30.8417 51.4586 26.3811 45.9636 26.3811C40.4687 26.3811 36.0081 30.9064 36.0081 36.4013V59.9973H27.9919V36.4013C27.9919 30.8417 23.4667 26.3811 17.9717 26.3811C12.4768 26.3811 8.01616 30.9064 8.01616 36.4013V59.9973H0V36.4013C0 26.4458 8.01616 18.365 17.9717 18.365C23.605 18.365 28.651 20.9861 31.9635 25.082C35.2526 20.9861 40.2936 18.365 45.9636 18.365ZM17.9071 0.0700073C22.1091 0.0700073 25.5354 3.49627 25.5354 7.69829C25.5354 11.9003 22.1091 15.3912 17.9071 15.3912C13.705 15.3912 10.3434 11.9003 10.3434 7.69829C10.3434 3.49627 13.705 0.0700073 17.9071 0.0700073ZM45.899 0.0700073C50.101 0.0700073 53.5273 3.49627 53.5273 7.69829C53.5273 11.9003 50.101 15.3266 45.899 15.3266C41.697 15.3912 38.3354 11.9003 38.3354 7.69829C38.3354 3.49627 41.697 0.0700073 45.899 0.0700073Z", ],
};

const oneOnOneIconSolid = {
	prefix: "fac",
	iconName: "one-on-one",
	icon: [ 20, 14, [], "e002", "M18 0H2C0.895313 0 0 0.895313 0 2V12C0 13.1047 0.895313 14 2 14H18C19.1047 14 20 13.1047 20 12V2C20 0.895313 19.1031 0 18 0ZM6 9.49999H7.25C7.66562 9.49999 8 9.83593 8 10.25C8 10.6641 7.66406 11 7.25 11H3.25C2.8375 11 2.5 10.6641 2.5 10.25C2.5 9.83593 2.83594 9.49999 3.25 9.49999H4.5V5.14999L4.04 5.42987C3.69469 5.65843 3.229 5.56562 3 5.22187C2.77187 4.90312 2.86563 4.43749 3.20906 4.20899L4.83406 3.12587C5.065 2.97156 5.36091 2.95787 5.60406 3.08874C5.84766 3.21968 6 3.47362 6 3.74999V9.49999ZM15.5 9.49999H16.75C17.1656 9.49999 17.5 9.83593 17.5 10.25C17.5 10.6641 17.1641 11 16.75 11H12.75C12.3375 11 12 10.6641 12 10.25C12 9.83593 12.3359 9.49999 12.75 9.49999H14V5.14999L13.54 5.42987C13.1947 5.65843 12.729 5.56562 12.5 5.22187C12.2719 4.90312 12.3656 4.43749 12.7091 4.20899L14.3341 3.12587C14.565 2.97156 14.8609 2.95787 15.1041 3.08874C15.3477 3.21968 15.5 3.47362 15.5 3.74999V9.49999ZM9.125 5.25C9.125 5.13389 9.125 5.07584 9.13142 5.02711C9.17572 4.69056 9.44056 4.42572 9.77711 4.38142C9.82584 4.375 9.88389 4.375 10 4.375C10.1161 4.375 10.1742 4.375 10.2229 4.38142C10.5594 4.42572 10.8243 4.69056 10.8686 5.02711C10.875 5.07584 10.875 5.13389 10.875 5.25C10.875 5.36611 10.875 5.42416 10.8686 5.47289C10.8243 5.80944 10.5594 6.07428 10.2229 6.11858C10.1742 6.125 10.1161 6.125 10 6.125C9.88389 6.125 9.82584 6.125 9.77711 6.11858C9.44056 6.07428 9.17572 5.80944 9.13142 5.47289C9.125 5.42416 9.125 5.36611 9.125 5.25ZM9.125 8.75C9.125 8.63389 9.125 8.57584 9.13142 8.52711C9.17572 8.19056 9.44056 7.92572 9.77711 7.88142C9.82584 7.875 9.88389 7.875 10 7.875C10.1161 7.875 10.1742 7.875 10.2229 7.88142C10.5594 7.92572 10.8243 8.19056 10.8686 8.52711C10.875 8.57584 10.875 8.63389 10.875 8.75C10.875 8.86611 10.875 8.92416 10.8686 8.97289C10.8243 9.30944 10.5594 9.57428 10.2229 9.61858C10.1742 9.625 10.1161 9.625 10 9.625C9.88389 9.625 9.82584 9.625 9.77711 9.61858C9.44056 9.57428 9.17572 9.30944 9.13142 8.97289C9.125 8.92416 9.125 8.86611 9.125 8.75Z", ],
};

const topicSolid = {
	prefix: "fac",
	iconName: "topic-solid",
	icon: [ 16, 16, [], "e003", "M13.7143 0.143066H2.28571C1.02321 0.143066 0 1.16628 0 2.42878V13.8574C0 15.1199 1.02321 16.1431 2.28571 16.1431H13.7143C14.9768 16.1431 16 15.1199 16 13.8574V2.42878C16 1.16628 14.975 0.143066 13.7143 0.143066ZM11.7143 5.28592H8.85714V11.8574C8.85714 12.3306 8.47321 12.7145 8 12.7145C7.52679 12.7145 7.14286 12.3306 7.14286 11.8574V5.28592H4.28571C3.81429 5.28592 3.42857 4.90378 3.42857 4.42878C3.42857 3.95378 3.81429 3.57164 4.28571 3.57164H11.7143C12.1893 3.57164 12.5714 3.95735 12.5714 4.42878C12.5714 4.90021 12.1893 5.28592 11.7143 5.28592Z", ],
};
/* eslint-enable no-magic-numbers */

// we aren't using any icons from this FA import yet, but leaving for future use/reference
// import {} from "@fortawesome/free-brands-svg-icons";

import {
	faAlignLeft as freeSolidAlignLeft,
	faAngleDoubleDown as freeSolidAngleDoubleDown,
	faAngleDoubleRight as freeSolidAngleDoubleRight,
	faAngleDoubleUp as freeSolidAngleDoubleUp,
	faAngleDown as freeSolidAngleDown,
	faArrowLeft as freeSolidArrowLeft,
	faArrowRight as freeSolidArrowRight,
	faArrowUp as freeSolidArrowUp,
	faBars as freeSolidBars,
	faBold as freeSolidBold,
	faBoxArchive as freeSolidBoxArchive,
	faBoxOpen as freeSolidBoxOpen,
	faCalendarDay as freeSolidCalendarDay,
	faCalendarWeek as freeSolidCalendarWeek,
	faCaretLeft as freeSolidCaretLeft,
	faChalkboardTeacher as freeSolidChalkboardTeacher,
	faCheck as freeSolidCheck,
	faCheckCircle as freeSolidCheckCircle,
	faCheckDouble as freeSolidCheckDouble,
	faCheckSquare as freeSolidCheckSquare,
	faChevronDown as freeSolidChevronDown,
	faChevronLeft as freeSolidChevronLeft,
	faChevronRight as freeSolidChevronRight,
	faCircleCheck as freeSolidCircleCheck,
	faCircleNotch as freeSolidCircleNotch,
	faClockRotateLeft as freeSolidClockRotateLeft,
	faCog as freeSolidCog,
	faDollarSign as freeSolidDollarSign,
	faEdit as freeSolidEdit,
	faEnvelope as freeSolidEnvelope,
	faEyeSlash as freeSolidEyeSLash,
	faFileLines as freeSolidFileLines,
	faGavel as freeSolidGavel,
	faGear as freeSolidGear,
	faHeading as freeSolidHeading,
	faImage as freeSolidImage,
	faInfoCircle as freeSolidInfoCircle,
	faItalic as freeSolidItalic,
	faLink as freeSolidLink,
	faList as freeSolidList,
	faListOl as freeSolidListOl,
	faListUl as freeSolidListUl,
	faPlus as freeSolidPlus,
	faPowerOff as freeSolidPowerOff,
	faQuestionCircle as freeSolidQuestionCircle,
	faRectangleList as freeSolidRectangleList,
	faShapes as freeSolidShapes,
	faSlidersH as freeSolidSlidersH,
	faSortDown as freeSolidSortDown,
	faSquare as freeSolidSquare,
	faStar as freeSolidStar,
	faStream as freeSolidStream,
	faSyncAlt as freeSolidSyncAlt,
	faTimes as freeSolidTimes,
	faUnderline as freeSolidUnderline,
	faUser as freeSolidUser,
	faUserGroup as freeSolidUserGroup,
	faUsers as freeSolidUsers
} from "@fortawesome/free-solid-svg-icons";

import {
	faArrowDownAZ as proDuotoneArrowDownAZ,
	faBullseyeArrow as proDuotoneBullseyeArrow,
	faCalendarCheck as proDuotoneCalendarCheck,
	faCalendarDay as proDuotoneCalendarDay,
	faCheckCircle as proDuotoneCheckCircle,
	faCheckDouble as proDuotoneCheckDouble,
	faChevronDoubleDown as proDuotoneChevronDoubleDown,
	faChevronDoubleUp as proDuotoneChevronDoubleUp,
	faHeadSideBrain as proDuotoneHeadSideBrain,
	faHeartbeat as proDuotoneHeartbeat,
	faPeopleArrows as proDuotonePeopleArrows,
	faSpinnerThird as proDuotoneSpinnerThird,
	faSquareArrowLeft as proDuotoneSquareArrowLeft
} from "@fortawesome/pro-duotone-svg-icons";

import {
	faArrowUpArrowDown as proRegularArrowUpArrowDown,
	faBarsStaggered as proRegularBarsStaggered,
	faBoltLightning as proRegularBoltLightning,
	faBullseyeArrow as proRegularBullseyeArrow,
	faCalendarCheck as proRegularCalendarCheck,
	faCalendarClock as proRegularCalendarClock,
	faCalendarDay as proRegularCalendarDay,
	faCalendarEdit as proRegularCalendarEdit,
	faCalendarLinesPen as proRegularCalendarLinesPen,
	faCalendarPlus as proRegularCalendarPlus,
	faCalendarRange as proRegularCalendarRange,
	faChartLineDown as proRegularChartLineDown,
	faChevronDoubleDown as proRegularChevronDoubleDown,
	faChevronDoubleUp as proRegularChevronDoubleUp,
	faChevronsRight as proRegularChevronsRight,
	faCircle as proRegularCircle,
	faCircleDot as proRegularCircleDot,
	faClock as proRegularClock,
	faCloudArrowUp as proRegularCloudArrowUp,
	faDna as proRegularDna,
	faDollarSign as proRegularDollarSign,
	faEllipsisH as proRegularEllipsisH,
	faEyeSlash as proRegularEyeSlash,
	faFileArrowDown as proRegularFileArrowDown,
	faFileAudio as proRegularFileAudio,
	faFileLines as proRegularFileLines,
	faFileVideo as proRegularFileVideo,
	faHandshakeSimple as proRegularHandshakeSimple,
	faHeadSideBrain as proRegularHeadSideBrain,
	faLightbulbOn as proRegularLightbulbOn,
	faMessageCheck as proRegularMessageCheck,
	faMessageLines as proRegularMessageLines,
	faMessages as proRegularMessages,
	faPeopleArrows as proRegularPeopleArrows,
	faPercent as proRegularPercent,
	faPersonCircleCheck as proRegularPersonCircleCheck,
	faPersonCircleExclamation as proRegularPersonCircleExclamation,
	faPipe as proRegularPipe,
	faPowerOff as proRegularPowerOff,
	faSparkles as proRegularSparkles,
	faSquare as proRegularSquare,
	faSquareArrowLeft as proRegularSquareArrowLeft,
	faStar as proRegularStar,
	faText as proRegularText,
	faTrash as proRegularTrash,
	faTrashCan as proRegularTrashCan,
	faTriangleExclamation as proRegularTriangleExclamation,
	faUserGroup as proRegularUserGroup,
	faUserLock as proRegularUserLock,
	faWaveformLines as proRegularWaveformLines
} from "@fortawesome/pro-regular-svg-icons";

import {
	faBook as proSolidBook,
	faBullseyeArrow as proSolidBullseyeArrow,
	faCalendarStar as proSolidCalendarStar,
	faCaretDown as proSolidCaretDown,
	faCaretUp as proSolidCaretUp,
	faCircleZ as proSolidCircleZ,
	faCommentAltLines as proSolidCommentAltLines,
	faCommentsQuestionCheck as proSolidCommentsQuestionCheck,
	faExclamationCircle as proSolidExclamationCircle,
	faExclamationSquare as proSolidExclamationSquare,
	faInputNumeric as proSolidInputNumeric,
	faInputText as proSolidInputText,
	faLockAlt as proSolidLockAlt,
	faMessageBot as proSolidMessageBot,
	faMinus as proSolidMinus,
	faSquareList as proSolidSquareList,
	faPenLine as proSolidPenLine,
	faSidebar as proSolidSidebar,
	faSidebarFlip as proSolidSidebarFlip,
	faSignOut as proSolidSignOut,
	faSquareT as proSolidSquareT,
	faUserTag as proSolidUserTag,
	faVideo as proSolidVideo,
	faInboxFull
} from "@fortawesome/pro-solid-svg-icons";

import {
	faCheckCircle as proLightCheckCircle,
	faCog as proLightCog,
	faPowerOff as proLightPowerOff,
	faThumbsDown as proLightThumbsDown,
	faThumbsUp as proLightThumbsUp
} from "@fortawesome/pro-light-svg-icons";


import {
	faCopy as freeRegularCopy
} from "@fortawesome/free-regular-svg-icons";

library.add(
	// custom icons
	teamingLogoSolid,
	oneOnOneIconSolid,
	topicSolid,
	// FA icons
	freeSolidAlignLeft,
	freeSolidAngleDoubleDown,
	freeSolidAngleDoubleRight,
	freeSolidAngleDoubleUp,
	freeSolidAngleDown,
	freeSolidArrowLeft,
	freeSolidArrowRight,
	freeSolidArrowUp,
	freeSolidBars,
	freeSolidBold,
	freeSolidBoxArchive,
	freeSolidBoxOpen,
	freeSolidCalendarDay,
	freeSolidCalendarWeek,
	freeSolidCaretLeft,
	freeSolidChalkboardTeacher,
	freeSolidCheck,
	freeSolidCheckCircle,
	freeSolidCheckDouble,
	freeSolidCheckSquare,
	freeSolidChevronDown,
	freeSolidChevronLeft,
	freeSolidChevronRight,
	freeSolidCircleCheck,
	freeSolidCircleNotch,
	freeSolidClockRotateLeft,
	freeSolidCog,
	freeSolidDollarSign,
	freeSolidEdit,
	freeSolidEnvelope,
	freeSolidEyeSLash,
	freeSolidFileLines,
	freeSolidGavel,
	freeSolidGear,
	freeSolidHeading,
	freeSolidImage,
	freeSolidInfoCircle,
	freeSolidItalic,
	freeSolidLink,
	freeSolidList,
	freeSolidListOl,
	freeSolidListUl,
	freeSolidPlus,
	freeSolidPowerOff,
	freeSolidQuestionCircle,
	freeSolidRectangleList,
	freeSolidShapes,
	freeSolidSlidersH,
	freeSolidSortDown,
	freeSolidSquare,
	freeSolidStar,
	freeSolidStream,
	freeSolidSyncAlt,
	freeSolidTimes,
	freeSolidUnderline,
	freeSolidUser,
	freeSolidUserGroup,
	freeSolidUsers,
	proDuotoneArrowDownAZ,
	proDuotoneBullseyeArrow,
	proDuotoneCalendarCheck,
	proDuotoneCalendarDay,
	proDuotoneCheckCircle,
	proDuotoneCheckDouble,
	proDuotoneChevronDoubleDown,
	proDuotoneChevronDoubleUp,
	proDuotoneHeadSideBrain,
	proDuotoneHeartbeat,
	proDuotonePeopleArrows,
	proDuotoneSpinnerThird,
	proDuotoneSquareArrowLeft,
	proLightCheckCircle,
	proLightCog,
	proLightPowerOff,
	proLightThumbsDown,
	proLightThumbsUp,
	proRegularArrowUpArrowDown,
	proRegularBarsStaggered,
	proRegularBoltLightning,
	proRegularBullseyeArrow,
	proRegularCalendarCheck,
	proRegularCalendarClock,
	proRegularCalendarDay,
	proRegularCalendarEdit,
	proRegularCalendarLinesPen,
	proRegularCalendarPlus,
	proRegularCalendarRange,
	proRegularChartLineDown,
	proRegularChevronDoubleDown,
	proRegularChevronDoubleUp,
	proRegularChevronsRight,
	proRegularCircle,
	proRegularCircleDot,
	proRegularClock,
	proRegularCloudArrowUp,
	proRegularDna,
	proRegularDollarSign,
	proRegularEllipsisH,
	proRegularEyeSlash,
	proRegularFileArrowDown,
	proRegularFileAudio,
	proRegularFileLines,
	proRegularFileVideo,
	proRegularHandshakeSimple,
	proRegularHeadSideBrain,
	proRegularLightbulbOn,
	proRegularMessageCheck,
	proRegularMessageLines,
	proRegularMessages,
	proRegularPeopleArrows,
	proRegularPercent,
	proRegularPersonCircleCheck,
	proRegularPersonCircleExclamation,
	proRegularPipe,
	proRegularPowerOff,
	proRegularSparkles,
	proRegularSquare,
	proRegularSquareArrowLeft,
	proRegularStar,
	proRegularText,
	proRegularTrash,
	proRegularTrashCan,
	proRegularTriangleExclamation,
	proRegularUserGroup,
	proRegularUserLock,
	proRegularWaveformLines,
	proSolidBook,
	proSolidBullseyeArrow,
	proSolidCalendarStar,
	proSolidCaretDown,
	proSolidCaretUp,
	proSolidCircleZ,
	proSolidCommentAltLines,
	proSolidCommentsQuestionCheck,
	proSolidExclamationCircle,
	proSolidExclamationSquare,
	proSolidInputNumeric,
	proSolidInputText,
	proSolidLockAlt,
	proSolidMessageBot,
	proSolidMinus,
	proSolidPenLine,
	proSolidSidebar,
	proSolidSidebarFlip,
	proSolidSignOut,
	proSolidSquareList,
	proSolidSquareT,
	proSolidUserTag,
	proSolidVideo,
	faInboxFull,
	freeRegularCopy
);

/*
REFERENCE

solid icons
<FontAwesomeIcon :icon="['fas', 'icon-name']" />

brand icons
<FontAwesomeIcon :icon="['fab', 'font-awesome']" />

regular icons
<FontAwesomeIcon :icon="['far', 'icon-name']" />

light icons
<FontAwesomeIcon :icon="['fal', 'icon-name']" />

duotone icons
<FontAwesomeIcon :icon="['fad', 'icon-name']" />

custom icons
<FontAwesomeIcon :icon="['fac', 'icon-name']" />

*/
